<template>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'i-tree',
        props: {
            enabledAdd: {
                type: Boolean,
                default: false
            },
            active: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            open: {
                type: Array,
                default: () => ([])
            },
            hasSearch: {
                type: Boolean,
                default: false
            },
            getRootUrl: {
                type: String,
                default: null
            },
            getChildUrl: {
                type: String,
                default: null
            },
            itemKey: {
                type: String,
                default: null
            },
            itemText: {
                type: String,
                default: null
            }
        },
        data: () => {
            return {
                search: "",
                activeNode: [],
                oldNode: [],
                openNode: [],
                items: [],
                selected: []
            }
        },

        watch: {
            activeNode: function (value) {
                this.$emit("update:active", value);
                //this.fetchItems(value);
            },
            openNode: function (value) {
                this.$emit("update:open", value);
                if(this.openNode.length == 0){
                    this.oldNode = this.openNode;
                    return;
                }
                ////console.log("--- before node ---");
                ////console.log(this.oldNode);
                ////console.log("--- new node ---");
                ////console.log(this.openNode);
                for(let i=0;i<this.openNode.length;i++){
                    let bNew = true;
                    for(let j=0;j<this.oldNode.length;j++){
                        if(this.oldNode[j][this.itemKey] == this.openNode[i][this.itemKey]){
                            bNew = false;
                            break;
                        }
                    }
                    if(bNew){
                        ////console.log("---new---")
                        ////console.log(this.openNode[i]);
                        this.fetchItems(this.openNode[i]);
                        break;
                    }
                }
                ////console.log("--- update node ---");
                this.oldNode = this.openNode;
/*
                ////console.log("--- open node ---");
                ////console.log(value);
                ////console.log("--- update value---");
                ////console.log(value[value.length - 1]);
                if(value.length >0) {
                    this.fetchItems(value[value.length - 1]);
                }


                ////console.log("--- items ---");
                ////console.log(this.items);
*/
            }

        },
        computed: {},

        methods: {
            closeAll: function(){
                this.openNode = [];
            },

            addNew: function () {
                this.$emit("add");
            },
            updateAll: function () {
                ////console.log(this.items);
                //this.activeNode = [];
                //this.closeAll();
                ////console.log(this.$refs.tree.nodes);
                //for(let key in this.$refs.tree.nodes){
                    //if(this.$refs.tree.nodes[key].)
                    //this.$refs.tree.nodes[key].isOpen = false;
                    //this.$refs.tree.nodes[key].isActive = false;
                //}
                //this.$refs.tree.updateAll(true);
                this.openNode = [];
                this.getRootItem();
                //this.oldNode = [];
                //this.openNode = [];
                ////console.log("--- open cache ---");
                ////console.log(this.$refs.tree.openCache);
                //this.$refs.tree.openCache = new Set();
                ////console.log("after update");
                //this.$refs.tree.updateAll(true);
            },

            updateNodeItem:function(item){
                ////console.log("here");
                for(let i=0;i<this.items.length;i++){
                    if(this.items[i][this.itemKey] == item[this.itemKey]){
                        this.items[i] = item;
                        break;
                    }
                }
                this.$set(this,"items",this.items);
                ////console.log(this.items);
            },

            filter(item, search, textKey) {
                return item[textKey].toLowerCase().indexOf(search.toLowerCase()) > -1;
            },

            fetchItemByURL(item, url) {
                ////console.log("load child");
                ////console.log(item);
                const prm = axios(process.env.VUE_APP_API_URL + url + "?" + this.itemKey + "=" + item[this.itemKey]);
                let [data] = Promise.all([prm]);
/*
                for (let i = 0; i < data.items.length; i++) {
                    data.items[i].children = [];
                }

                for(let key in this.$refs.tree.nodes){
                    this.$refs.tree.nodes[key].isOpen = false;
                }
*/


                if (item[this.itemKey] == 0) {
/*
                    ////console.log("---update root---")
                    ////console.log(data.items);
*/
                    this.openNode = [];
                    let items = [];
                    for(let i=0;i<this.items.length;i++){
                        items.push(this.items[i]);
                    }
                    for(let i=items.length-1;i>=0;i--){
                        let bhas = false;
                        for(let j=0;j<data.items.length;j++) {
                            if(items[i][this.itemKey] == data.items[j][this.itemKey]) {
                                bhas = true;
                            }
                        }
                        if(!bhas){
                            items.splice(i,1);
                        }
                    }

                    for(let i=0;i<data.items.length;i++){
                        let bHas = false;
                        for(let j=0;j<items.length;j++){
                            if(data.items[i][this.itemKey] == items[j][this.itemKey]){
                                for(let key in data.items[i]){
                                    items[j][key] = data.items[i][key];
                                }
                                ////console.log(items[j]);
                                bHas = true;
                                break;
                            }
                        }
                        if(!bHas){
                            items.push(data.items[i]);
                        }
                    }
                    for (let i = 0; i < items.length; i++) {
                        if(items[i].children == undefined || items[i].children == null) {
                            items[i].children = [];
                        }
                    }

//                    ////console.log(items);
                    this.items = items;

                    //this.$refs.tree.buildTree(data.items);
                    //this.$refs.tree.openCache = new Set();
                    //this.$refs.tree.nodes = {};
                    /*
                    ////console.log(this.$refs.tree);
                    ////console.log(this.$refs.tree.nodes);
                    ////console.log(this.$refs.tree.selectedCache);
                    ////console.log(this.$refs.tree.activeCache);
                    ////console.log(this.$refs.tree.openCache);
*/
                } else {
//                    ////console.log("---update child---")
                    for (let i = 0; i < data.items.length; i++) {
                        data.items[i].children = [];
                    }
                    item.children = [];

                    if (data.items != null && data.items.length > 0) {
                        item.children.push(...data.items);
                    }
                }
//                ////console.log(item);
                return item;
            },

            updateChild(keyValue){
                return
            },

            fetchItems(item) {
                return this.fetchItemByURL(item, this.getChildUrl);
            },

            updateRootItem(){

            },

            getRootItem() {
                let item = {};
                item[this.itemKey] = 0;
                return this.fetchItemByURL(item, this.getRootUrl);
            }

        },

        created() {
            this.activeNode = this.active;
            this.openNode = this.open;
            this.getRootItem();
        },
    }
</script>
